import React, { useState, useEffect, useRef } from "react";
import { Row, Container, Col, Form, Button, Modal } from "react-bootstrap";
import SaveChanges from "./SaveChanges";
import DeleteOrgModal from "organization_management/DeleteOrgModal";
import DefaultAvatar from "utils/DefaultAvatar";
import CustomAvatar from "utils/CustomAvatar";
import showAlert from "utils/showAlert";

export default function OrgInfo(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const formSubmitUrl = `/datapulse/organization`;
  let defaultLogo = require("images/organizations/orgLogo.png");
  const [fileName, setFileName] = useState("No File Chosen");
  const inputRef = useRef();
  const [imageURL, setImageURL] = useState(props.logo ? props.logo : `/datapulse${defaultLogo}`);
  let OrgLogo = <img src={imageURL} />;
  let upload = require("images/organizations/upload.png");
  upload = <img style={{paddingBottom:"3px", paddingRight:"12px"}} src={`/datapulse${upload}`} />;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({});
  const [deleteLocked, setDeleteLocked] = useState(true);
  const [zIndexFirst, setZIndexFirst] = useState(2500);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [toggledUsers, setToggledUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(Object.entries(props.org_users).length > 0 ? Object.entries(props.org_users).map((el) => el[1]).filter(item => item.id === props.owner.id)[0].email : []);
  const unSelectedUsers = Object.entries(props.org_users).map((el) => el[1]).filter(item => item.role === "admin").map((user) => user.email);
  const [visibleUsers, setVisibleUsers] = useState([...unSelectedUsers]);
  const [newOwnerId, setNewOwnerId] = useState();
  
  // API Keys state
  const [apiKeys, setApiKeys] = useState(props.api_keys || []);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  const [newApiKeyName, setNewApiKeyName] = useState('');
  const [generatedApiKey, setGeneratedApiKey] = useState('');
  const [showApiKeyValue, setShowApiKeyValue] = useState(false);

  let caution = require("images/icons/exclaim-triangle.png");
  caution = <img className="px-4 d-inline-block" src={`/datapulse${caution}`} />;

  const handleShow2 = () => {
    setShow2(true);
    setZIndexFirst(1000);
  };

  const handleClose2 = () => {
    setShow2(false);
    setZIndexFirst(3001);
  };

  useEffect(() => {
    setVisibleUsers(Object.entries(props.org_users).map((el) => el[1]).filter(item => item.role === "admin" && item.id !== props.owner.id).map((user) => user.email));
  }, [selectedUsers]);

  useEffect(() => {
    const capturedId = Object.entries(props.org_users).map((el) => el[1]).filter(item => item.email === toggledUsers[0]).map((user) => user.id)[0];
    setNewOwnerId(capturedId);
  }, [toggledUsers]);

  const toggleUser = (e) => {
    let userEmail = e.target.getAttribute("data-email");
    let selection = [...toggledUsers];
    if (selection.includes(userEmail)) {
      selection.splice(selection.indexOf(userEmail), 1);
    } else {
      selection.pop();
      selection.push(userEmail);
    }
    setToggledUsers(selection);
  };

  const handleCancel = () => {
    setToggledUsers([]);
    handleClose();
  };

  const searchUsers = (e) => {
    let filter = e.target.value.toLowerCase();
    let matchedUsers = [];
    unSelectedUsers.forEach((userEmail) => {
      let user = props.org_users[userEmail];
      if (!selectedUsers.includes(userEmail) && (user.name.toLowerCase().includes(filter) || userEmail.toLowerCase().includes(filter))) {
        matchedUsers.push(userEmail);
      }
    });
    setVisibleUsers(matchedUsers);
  };

  const toggledUsersList = toggledUsers.map((userEmail) => {
    let user = props.org_users[userEmail];
    return (
      <span key={user.id} data-email={userEmail} onClick={(e) => toggleUser(e)}>
        {user.name}
        <i style={{ pointerEvents: "none" }} className="fa fa-times"></i>
      </span>
    );
  });

  const confirmDelete = (org) => {
    setDeleteTarget(org);
    setShowDeleteModal(true);
  };

  const deleteOrg = (org) => {
    props.handleOrgDelete();
  };

  const copyInviteCode = () => {
    navigator.clipboard.writeText(props.org.invite_code);
    showAlert("Invite code copied to clipboard!", "success");
  };

  const createApiKey = async () => {
    if (!newApiKeyName.trim()) {
      showAlert("Please enter a name for the API key", "error");
      return;
    }

    try {
      const response = await $.ajax({
        type: "POST",
        url: `/datapulse/organization/${props.org.id}/api-keys`,
        data: {
          name: newApiKeyName,
          authenticity_token: authenticityToken
        }
      });

      if (response.success) {
        setGeneratedApiKey(response.api_key.key);
        setShowApiKeyValue(true);
        setApiKeys([...apiKeys, response.api_key]);
        setNewApiKeyName('');
        showAlert("API key created successfully!", "success");
      } else {
        showAlert(response.error || "Failed to create API key", "error");
      }
    } catch (error) {
      showAlert("Error creating API key", "error");
      console.error(error);
    }
  };

  const deleteApiKey = async (apiKeyId, apiKeyName) => {
    if (!confirm(`Are you sure you want to delete the API key "${apiKeyName}"? This action cannot be undone.`)) {
      return;
    }

    try {
      const response = await $.ajax({
        type: "DELETE",
        url: `/datapulse/organization/${props.org.id}/api-keys/${apiKeyId}`,
        data: {
          authenticity_token: authenticityToken
        }
      });

      if (response.success) {
        setApiKeys(apiKeys.filter(key => key.id !== apiKeyId));
        showAlert("API key deleted successfully!", "success");
      } else {
        showAlert(response.error || "Failed to delete API key", "error");
      }
    } catch (error) {
      showAlert("Error deleting API key", "error");
      console.error(error);
    }
  };

  const copyApiKey = (apiKey) => {
    navigator.clipboard.writeText(apiKey);
    showAlert("API key copied to clipboard!", "success");
  };

  const handleCloseApiKeyModal = () => {
    setShowApiKeyModal(false);
    setNewApiKeyName('');
    setGeneratedApiKey('');
    setShowApiKeyValue(false);
  };

  return (
    <>
      <Form className="sec-bg" id="organization-info-form" method="post" encType="multipart/form-data" action={formSubmitUrl}>
        <input hidden name="organization_id" value={props.org.id} readOnly />
        <input hidden name="authenticity_token" value={authenticityToken} readOnly />
        <div className="fixed-action-bar">
          <SaveChanges />
        </div>
        <h2 className="">Organization Settings</h2>
        <div className="lite-basic-container">
          <div className="lite-basic-left subcontainer">
            <div className="company-display-name">
              <p className="input-label">Organization Name</p>
              <input
                type="text"
                name="organization_name"
                maxLength="30"
                defaultValue={props.org.name}
                className="lite-modal-input"
              />
            </div>
            <div className="company-website">
              <p className="input-label">Location</p>
              <input
                type="text"
                name="organization_location"
                maxLength="40"
                defaultValue={props.org.location}
                className="lite-modal-input"
              />
            </div>
            <div className="lite-dashboard-objective">
              <p className="input-label">Type</p>
              <div className="select-wrapper">
                <select 
                  name="organization_type" 
                  defaultValue={props.org.organization_type}
                  className="lite-modal-select lite-select"
                >
                  <option value="agency">Agency</option>
                  <option value="business">Business</option>
                </select>
              </div>
            </div>
            {props.isOwner && (
            <div className="owner-actions">
              <p className="input-label">Owner Actions</p>
              <div className="owner-actions-button-container">
                <button 
                  type="button"
                  className="button b-type-secondary b-size-small"
                  onClick={handleShow}
                >
                  Transfer Ownership
                </button>
                <button 
                  type="button"
                  className="button b-type-danger b-size-small b-color-red"
                  onClick={() => confirmDelete(props.org)} 
                  disabled={props.isPrimaryOrg}
                >
                  Delete this organization
                </button>
              </div>
            </div>
          )}
          </div>
          <div className="lite-basic-middle subcontainer">
            <div className="lite-overview-datasource">
              <p className="input-label">Description</p>
              <textarea
                name="organization_description"
                rows={12}
                defaultValue={props.org.description}
                placeholder="Tell us a bit about what your organization does..."
                className="lite-modal-textarea"
              ></textarea>
            </div>
          </div>
          <div className="lite-basic-right subcontainer">
            <div className="lite-logo">
              <div>
                <p className="input-label">Organization Logo</p>
              </div>
              <div className="logo-display">
                {OrgLogo}
              </div>
              <div>
                <input
                  ref={inputRef}
                  style={{ display: "none" }}
                  name="organization_logo"
                  type="file"
                  onChange={(e) => {
                    if (e.target.files[0].size > 8000000) {
                      alert("Image must be less than 8MB. Consider using another image or compress this one.");
                    }
                    setImageURL(URL.createObjectURL(e.target.files[0]));
                    setFileName(e.target.files[0].name);
                  }}
                />
                <button 
                  type="button"
                  className="button b-type-secondary b-size-small icon-upload"
                  onClick={() => inputRef.current.click()}
                >
                  {upload}Upload Image
                </button>
              </div>
              <div className="logo-note">
                <p>
                  Accepted file types: JPG, PNG, SVG<br />
                  Minimum file dimensions: 100x100px<br />
                  Ideal ratio 1:1<br />
                  Maximum file size: 8 MB
                </p>
              </div>
            </div>
          </div>
          <div className="subcontainer full-width" style={{gap: "0px"}}>
            <div className="invite-code-section mt-2 ml-0">
              <h4 className="invite-code">Invite code: {props.org.invite_code}</h4>
              <button className="copy-icon" type="button" onClick={copyInviteCode}>
                <img src={`/datapulse${require("images/lite/icons/paste.png")}`} alt="Copy Icon" className="filter-grey" />
              </button>
            </div>
            <p>
              (Send this code to users who you would like to join '{props.org.name}'. User's who join using the code will be added as employees and given access to all accounts.
              This can be changed at any time with the <a href="/datapulse/user-access">User Access</a> page.)
            </p>
          </div>
          
          {/* API Keys Section */}
          {(true) && (
            <div className="subcontainer full-width" style={{gap: "0px"}}>
              <div className="api-keys-section mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4>DataPulse API Keys</h4>
                  <button 
                    type="button"
                    className="button b-type-primary b-size-small"
                    onClick={() => setShowApiKeyModal(true)}
                  >
                    Generate New API Key
                  </button>
                </div>
                
                {apiKeys.length > 0 ? (
                  <div className="api-keys-list">
                    {apiKeys.map((apiKey) => (
                      <div key={apiKey.id} className="api-key-item d-flex justify-content-between align-items-center p-3 mb-2 border rounded">
                        <div>
                          <strong>{apiKey.name}</strong>
                          <div className="small text-muted">
                            Created: {new Date(apiKey.created_at).toLocaleDateString()}
                            {apiKey.last_used_at && (
                              <span> • Last used: {new Date(apiKey.last_used_at).toLocaleDateString()}</span>
                            )}
                          </div>
                          <div className="small text-muted">
                            Key: {apiKey.key ? `${apiKey.key.substring(0, 8)}...` : 'dpk_••••••••'}
                          </div>
                        </div>
                        <div>
                          {apiKey.key && (
                            <button 
                              type="button"
                              className="button b-type-secondary b-size-small me-2"
                              onClick={() => copyApiKey(apiKey.key)}
                            >
                              Copy
                            </button>
                          )}
                          <button 
                            type="button"
                            className="button b-type-danger b-size-small"
                            onClick={() => deleteApiKey(apiKey.id, apiKey.name)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No API keys created yet. Generate your first API key to access the DataPulse API programmatically.</p>
                )}
                
                <p className="small text-muted mt-3">
                  API keys provide programmatic access to your DataPulse data. Keep them secure and rotate them regularly. 
                  See the <a href="/datapulse/API_DOCUMENTATION.md" target="_blank">API documentation</a> for usage details.
                </p>
              </div>
            </div>
          )}
        </div>
      </Form>
      <Modal className="users-select-modal" show={show} onHide={handleClose} style={{ zIndex: zIndexFirst }}>
        <div className="page-1">
          <Modal.Header closeButton>
            <Modal.Title>Select new organization owner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <div className="user-search">
                  <span className="fa fa-search"></span>
                  <input onChange={(e) => searchUsers(e)} placeholder="Enter a name or email address..." />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <ul className="user-list">
                  {visibleUsers.map((userEmail) => {
                    let user = props.org_users[userEmail];
                    let avatar = <DefaultAvatar dim="32x32" name={user.name} className="avatar" department={user.department} />;
                    if (user.avatar) {
                      avatar = <CustomAvatar src={user.avatar} className="avatar" department={user.department} />;
                    }
                    let toggled = toggledUsers.includes(userEmail) ? "toggled" : undefined;
                    return (
                      <React.Fragment key={user.id}>
                        <li onClick={(e) => toggleUser(e)} data-email={userEmail} className={toggled}>
                          <div style={{ pointerEvents: "none" }}>
                            <div className="d-inline-block m-0">
                              <div className="position-relative d-inline-block">
                                {avatar}
                                <div className="overlay">
                                  <i className="fa fa-check"></i>
                                </div>
                              </div>
                              <b className="users-name">&nbsp;{user.name}</b>
                              <span>&nbsp;{userEmail}</span>
                            </div>
                          </div>
                        </li>
                      </React.Fragment>
                    );
                  })}
                </ul>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="toggled-users">
              <p>
                <b>Transfer ownership to:</b>
              </p>
              {toggledUsersList}
            </div>
            <div>
              <Button style={{ backgroundColor: "#A3A3A3" }} onClick={handleCancel}>
                Cancel
              </Button>
              <Button variant="success" disabled={!newOwnerId} onClick={() => handleShow2()}>
                Transfer Ownership
              </Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
      <Modal className="secondary-modal relinquish-ownership-modal" show={show2} onHide={handleClose2} style={{ zIndex: 3007 }}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {caution}{"  "}
            <h4 className="d-inline-block">ARE YOU SURE?</h4>
          </Modal.Title>
        </Modal.Header>
        <div className="">
          <Modal.Body>
            <Row className="pb-4">
              <Col>
                <p>By relinquishing ownership you will lose access to ownership features</p>
              </Col>
            </Row>
            <div className="d-flex modal-buttons">
              <button type="button" className="button b-type-secondary b-size-small" onClick={handleClose2}>
                Cancel
              </button>
              <button type="button" className="button b-type-primary b-size-small" onClick={() => props.handleOwnershipTransfer(newOwnerId)}>
                Confirm
              </button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <DeleteOrgModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        deleteTarget={deleteTarget}
        setDeleteLocked={setDeleteLocked}
        deleteOrg={deleteOrg}
        deleteLocked={deleteLocked}
      />
      
      {/* API Key Creation Modal */}
      <Modal show={showApiKeyModal} onHide={handleCloseApiKeyModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {showApiKeyValue ? 'API Key Generated' : 'Generate New API Key'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showApiKeyValue ? (
            <div>
              <div className="alert alert-success">
                <strong>Success!</strong> Your API key has been generated.
              </div>
              <div className="alert alert-warning">
                <strong>Important:</strong> This is the only time you'll see the full API key. Copy it now and store it securely.
              </div>
              <div className="form-group">
                <label>Your API Key:</label>
                <div className="input-group">
                  <input 
                    type="text" 
                    className="form-control" 
                    value={generatedApiKey} 
                    readOnly 
                  />
                  <button 
                    className="btn btn-outline-secondary" 
                    type="button"
                    onClick={() => copyApiKey(generatedApiKey)}
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <p>Create a new API key to access DataPulse data programmatically.</p>
              <div className="form-group">
                <label htmlFor="apiKeyName">API Key Name:</label>
                <input 
                  type="text" 
                  id="apiKeyName"
                  className="form-control" 
                  value={newApiKeyName}
                  onChange={(e) => setNewApiKeyName(e.target.value)}
                  placeholder="e.g., Production API Key, Development Key"
                  maxLength="50"
                />
                <small className="form-text text-muted">
                  Choose a descriptive name to help you identify this key later.
                </small>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {showApiKeyValue ? (
            <Button variant="secondary" onClick={handleCloseApiKeyModal}>
              Close
            </Button>
          ) : (
            <>
              <Button variant="secondary" onClick={handleCloseApiKeyModal}>
                Cancel
              </Button>
              <Button 
                variant="primary" 
                onClick={createApiKey}
                disabled={!newApiKeyName.trim()}
              >
                Generate API Key
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}